<template>
    <div class="row">
        <div class="col-12 col-lg-8" v-if="!loading">
            <table class="table table-bordered" :class="{ 'table-responsive': lista_abonados.permitir_envio_a_domicilio && envio_domicilio && envio_whatsapp && datos_guardados && datos_guardados[0].plazos}">
                <tr class="altcolor-content">
                    <th v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio || datos_guardados && datos_guardados[0].plazos || envio_whatsapp"></th>
                    <th>{{ $t('general.abono', {abono: teatro.texto_abono}) }}</th>
                    <th v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio">{{ $t('general.gastos_envio') }}</th>
                    <th v-if="datos_guardados && datos_guardados[0].plazos">{{ $t('perfil.plazos') }}</th>
                    <th v-else-if="!lista_abonados.permitir_envio_a_domicilio && envio_domicilio"></th>
                    <th class="price" :colspan="!envio_domicilio && (datos_guardados && !datos_guardados[0].plazos) && !envio_whatsapp ? '2' : '0'">{{ $t('general.precio') }}</th>
                </tr>
                <tr v-for="(entrada, index) in datos_guardados" :key="index">
                    <td class="h1 text-center regular">{{++index}}</td>
                    <td>
                        <strong class="text-bold h5 d-block mb-1">{{ entrada.descuento.tipo ? entrada.descuento.tipo : entrada.descuento.descripcion }}</strong>
                        <template v-if="entrada.asiento">
                            <strong class="text-bold h7 d-block mb-1" v-if="entrada.asiento.zona_nombre">{{ entrada.asiento.zona_nombre }}</strong>
                            <strong class="text-bold h7 d-block mb-1" v-if="entrada.asiento.zona_nombre"> {{ $t('general.fila') }}: {{ entrada.asiento.fila }} - {{ $t('general.butaca') }}: {{ entrada.asiento.asiento }}</strong>
                            <span v-if="entrada.asiento.visibilidad_reducida || entrada.asiento.porcentaje_visibilidad">
                                &nbsp;-&nbsp;
                            </span>
                            <span v-if="entrada.asiento.visibilidad_reducida" class="text-danger">
                                {{ $t('visibilidad_reducida.nombre') }}
                            </span>
                            <span v-if="entrada.asiento.porcentaje_visibilidad" class="text-danger">
                                : {{ entrada.asiento.porcentaje_visibilidad }}%
                            </span>
                        </template>
                        <template v-else-if="entrada.plaza">
                            <strong class="text-bold h7 d-block mb-1" v-if="entrada.plaza.sector_name">{{ entrada.plaza.sector_name }}</strong>
                            <strong class="text-bold h7 d-block mb-1" v-if="entrada.plaza.fila && entrada.plaza.butaca"> 
                                {{ $t('general.fila') }}: {{ entrada.plaza.fila }} - {{ $t('general.butaca') }}: {{ entrada.plaza.butaca }}
                            </strong>
                            <strong class="text-bold h7 d-block mb-1" v-else> 
                                {{ $t('general.plaza') }} {{ entrada.plaza.numero }}
                            </strong>
                            <span v-if="entrada.plaza.visibilidad_reducida" class="text-danger">
                                {{ $t('visibilidad_reducida.nombre') }}
                            </span>
                            <span v-if="entrada.plaza.porcentaje_visibilidad" class="text-danger">
                                : {{ entrada.plaza.porcentaje_visibilidad }}%
                            </span>
                        </template>
                        <strong v-else class="text-bold h7 d-block mb-1">{{ entrada.tipo_abono.descripcion }}</strong>
                    </td>
                    <td v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio"></td>
                    <td v-if="entrada.plazos_pendientes?.length">
                        <ul class="p-2">
                            <li v-for="(plazo, key) in entrada.plazos_pendientes" :key="key">
                                <template >
                                    Plazo: {{ ++key }} ({{ plazo.fecha_pago }}) - {{ plazo.importe  | formatear_precio }}
                                </template>                                            
                            </li>
                        </ul>
                        <p v-if="!entrada.tipo_abono.plazos_abonados_pueden_acceder"><small>*{{ $t('nuevo_abono.advertencia_pago') }}</small></p>   
                    </td>
                    <td class="pr-0">
                        <template v-if="!entrada.voucher && !entrada.descuento_monedero && entrada.plazos_pendientes?.length">
                            <del class="h3 m-0">{{ entrada.descuento.precio | formatear_precio }}</del> <small>(Importe sin plazos)</small>
                        </template>
                        <template v-if="!entrada.voucher && !entrada.descuento_monedero">
                            <div class="h3 m-0">
                                {{ entrada.plazos_pendientes?.length
                                    ? entrada.plazos_pendientes[0].importe
                                    : entrada.descuento.precio + costeWhatsapp | formatear_precio
                                }}
                            </div>
                        </template>

                        <template v-else>
                            <del class="h5 m-0">
                                {{ entrada.descuento.precio_total + costeWhatsapp | formatear_precio }}
                            </del>
                            <small class="ml-1" v-if="entrada.descuento_monedero && !entrada.voucher">
                                ({{ entrada.descuento_monedero | formatear_precio }} Dto Monedero)
                            </small>
                            <small class="ml-1" v-if="entrada.voucher && (entrada.voucher.discount_fixed > 0 || entrada.voucher.discount_percent > 0)">
                                ({{ entrada.voucher.discount_fixed > 0 ? ($n(entrada.voucher.discount_fixed, "currency")) : entrada.voucher.discount_percent + '%' }} Dto Cupón)
                            </small>

                            <div v-if="entrada.voucher">
                                <template v-if="entrada.descuento_monedero && entrada.descuento_monedero > 0">
                                    <del class="h5 m-0">
                                        {{ calcularDescuento(entrada, false, true, false) + costeWhatsapp | formatear_precio }}
                                    </del>
                                    <small class="ml-1">
                                        ({{ entrada.descuento_monedero | formatear_precio }} Dto Monedero)
                                    </small>
                                </template>
                                <div v-if="entrada.plazos_pendientes?.length">
                                    <del class="h5 m-0">
                                        {{ calcularDescuento(entrada, false, true, true) + costeWhatsapp | formatear_precio }}
                                    </del>
                                    <small class="ml-1">(Importe sin plazos)</small>
                                </div>
                            </div>

                            <div class="h3 m-0">
                                {{ calcularDescuento(entrada, true, true, true) + costeWhatsapp | formatear_precio }}
                            </div>
                        </template>
                    </td>
                </tr>
                <template v-if="datos_parcelas_compra && datos_parcelas_compra.length > 0">
                    <tr v-for="(parcela, parcelaIndex) in datos_parcelas_compra" :key="`parcela-${parcelaIndex}`">
                        <td class="h1 text-center regular"></td>
                        <td>
                            <strong class="text-bold h5 d-block mb-1">Parcelas</strong>
                            <strong class="text-bold h7 d-block mb-1">{{ parcela.zona_nombre }}</strong>
                            <strong class="text-bold h7 d-block mb-1">Parcela Nº {{ parcela.numero }}</strong>
                        </td>
                        <td v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio"></td>
                        <td v-if="datos_guardados[0].plazos_pendientes?.length"></td>
                        <td>
                            <div class="h3 m-0">
                                {{ 
                                    parcela.precioSeleccionado.precio | formatear_precio 
                                }}
                            </div>
                        </td>
                    </tr>
                </template>
                <tr>
                    <td :colspan="datos_guardados[0].plazos_pendientes?.length && !envio_domicilio ? '3' : '2'"></td>
                    <td v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio">
                        <strong>
                            <div class="h3 m-0">{{ lista_abonados.precio_envio_a_domicilio | formatear_precio }}</div>
                        </strong>
                    </td>
                    <td v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio && datos_guardados[0].plazos_pendientes?.length"></td>
                    <td><span class="total-price h2 m-0">{{ datos_guardados[0].plazos ? total_plazos : (datos_parcelas_compra && datos_parcelas_compra.length > 0 ? total_con_parcelas : total) | formatear_precio }}<small v-if="datos_guardados && !datos_guardados[0].descuento.price_management_interno">*</small></span></td>
                </tr>
            </table>
            <p class="h5" v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio">{{ $t('nuevo_abono.precio_total_incluye') }} ({{ lista_abonados.precio_envio_a_domicilio | formatear_precio }}).</p>
            <h3 class="mb-4 mb-lg-5" v-if="lista_abonados.permitir_envio_a_domicilio && envio_domicilio"><b>{{ $t('nuevo_abono.direccion_envio') }} </b>{{ datos_guardados[0].datos_envio.domicilio }}, {{ datos_guardados[0].datos_envio.cp }}</h3>
        </div>
        <b-col cols="12" v-else>
            <div
                class="loader-container"
                style="height: 100px"
            >
                <LoaderComponent />
            </div>
        </b-col>
        <b-col lg="8" class="mb-4" v-if="datos_guardados && frecuencias && teatro.permitir_plazos_abonados == 1">
            <AddPlazosComponent
                :frecuencias="frecuencias"
                :min_plazos="min_plazos"
                :max_plazos="max_plazos"
                :gastos="datos_guardados[0].descuento.price_management"
                :tiene_gastos="datos_guardados[0].descuento.price_management_interno ? false : true"
                :error_plazos="error_plazos"
                :disabled="desactivar"
                @terminado="solicitarPlazos"
                @reset="resetPlazos"
            />
        </b-col> 
        <div class="col-12 col-lg-8 p-0">
            <template v-if="datos_guardados">
                <ResumenPrecioComponent 
                    :price="datos_guardados[0].plazos ? total_plazos_sin_gd : (datos_parcelas_compra && datos_parcelas_compra.length > 0 ? total_sin_gd_con_parcelas : total_sin_gd)" 
                    :price_management_interno="getGastosInternos()" 
                    :price_management="total_gd + importeTotalWhatsapp" 
                    :iva="iva" 
                    :abonos="datos_guardados"
                />
            </template>
        </div>
        <b-col cols="12" lg="8" v-if="activar_referidos && teatro.hash != 'PSaG3BjUboDrGdZz6SQq'">
            <BuscarReferidosComponent
                :session_id="session_id"
                :desactivar="desactivar"
            />
        </b-col>
        <b-col cols="12" lg="8" v-if="activar_saldo_monedero && datos_guardados && datos_guardados[0].importe_monedero > 0">
            <SaldoMonederoComponent
                :saldo_disponible="datos_guardados[0].importe_monedero"
                :importe="total_sin_gd"
                @confirmado="aplicarDescuento"
                :descuento_aplicado="datos_guardados[0].descuento_monedero === undefined ? 0 : parseFloat(datos_guardados[0].descuento_monedero)"
                @cancelar="cancelarDescuento"
            />
        </b-col>
        <div class="col-12 col-lg-8">
            <div class="col-12 col-lg-8 mt-3 p-0">
                <FormTerminos
                    :error="error"
                    :condiciones_plazos="footer.condiciones_abonos_plazos"
                    :texto_condiciones="texto_condiciones"
                    :pago_plazos="teatro.permitir_plazos_abonados && quiere_plazos"
                    :desactivar="desactivar"
                    @continuar="aceptarCondiciones"
                />
            </div>
            <button id="terminar-compra" class="button large-button effect-button" :disabled="desactivar" @click.prevent="terminar"><span>{{ $t('nuevo_abono.continuar') }}</span></button>
            <button id="atras-compra" class="button large-button effect-button ml-2" :disabled="desactivar" @click="volver"><span>{{ $t('nuevo_abono.atras') }}</span></button>
            <template v-if="formulario != null" >
                <div id="formulario-compra" v-html="formulario" v-show="false"></div>
            </template>
        </div>
    </div>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";
    import BuscarReferidosComponent from '@/components/frontend/abonos/nuevo/BuscarReferidosComponent.vue';
    import SaldoMonederoComponent from './SaldoMonederoComponent.vue';
    import AddPlazosComponent from '../../compra/plazos/AddPlazosComponent.vue';

    export default {
        props: ['formulario', 'datos_guardados', 'envio_domicilio' , 'iva', 'activar_referidos', 'session_id', 'activar_saldo_monedero', 'loading', 'desactivar','datos_parcelas_compra'],
        data() {
            return {
                error: false,
                solicitar_iban: false,
                iban: '',
                titular_cuenta: '',
                terminos: false,
                privacidad: false,
                condiciones: false,
                comunicaciones: false,
                condiciones_plazos: false,
                min_plazos: null,
                max_plazos: null,
                frecuencias: null,
                error_plazos: false,
                quiere_plazos: false,
                texto_condiciones: `
                    <p>1. Las cuotas indicadas en los plazos indicados se cobrarán automáticamente en la misma cuenta / Tarjeta que efectúa la primera cuota del plazo. No tendrá que realizar ningún movimiento.</p>
                    <p>2. El incumplimiento de alguno de los plazos de pago podrá suponer la invalidación del abono.</p>
                    <p>3. Si el cobro de las cuotas no se establece en el periodo indicado podrá suponer la prohibición de asistencia al recinto.</p>
                    <p>4. Podrá cancelar las cuotas indicadas desde su perfil abonando el importe total en un solo pago cuando usted quiera.</p>
                    <p>5. En caso de no realizar los pagos en los plazos indicados la organización podrá contactar con usted y ayudarle en lo posible.</p>
                    <p>6. Una vez abonadas las cuantías económicas de los plazos indicados no permitirá solicitar la devolución del importe aunque el producto haya sido cancelado por incumplimiento de alguno de los plazos de pago.</p>
                    <p>7. La organización podrá dar de baja la numeración del abono por incumplimiento de los plazos.</p>
                    <p>8. La organización podrá dar de baja el asiento elegido, en caso de ser asientos numerados si cualquiera de los plazos de pago no ha sido cumplido en las fechas indicados.</p>
                    <p>9. En caso de su tarjeta / Cuenta sufra alguna modificación deberá contactar con la organización, o podrá actualizar los datos en su perfil.</p>
                    <p>10. El coste del servicio corresponde a 0,96€ (iva incluido) por cada uno de los plazos de pago solicitados.</p>
                    <p>11. Podrá saber la situación de cobros y fechas de cobro en su perfil.</p>
                `
            }
        },
        watch: {
            loading(newValue) {
                if(newValue == false) {
                    this.setConfigPlazos();
                }
            }
        },
        computed: {
            importeTotalWhatsapp() {
                let total = 0;
                if (this.datos_guardados && this.datos_guardados.length > 0) {
                    this.datos_guardados.forEach(entrada => {
                        total += this.costeWhatsapp;
                    });
                }
                return total;
            },
            costeWhatsapp() {
                return parseFloat(this.teatro.coste_envio_whatsapp || 0);
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            sumar_gastos_whatsapp() {
                let gastos_abono = false;
                let gastos_parcelas = false;

                if (!this.datos_guardados[0].descuento.price_management_interno) {
                    gastos_abono = true;
                }
                
                if (this.datos_parcelas_compra?.length && !this.datos_parcelas_compra[0].precioSeleccionado.price_management_interno) {
                    gastos_parcelas = true;
                }

                return gastos_abono && gastos_parcelas;
            },
            total_plazos() {
                var total = 0;
                for(var i in this.datos_guardados) {
                    if (this.datos_guardados[i].plazos_pendientes) {
                        if(this.datos_guardados[i].plazos_pendientes[0].gastos_internos == 0) {
                            total = total + parseFloat(this.datos_guardados[i].plazos_pendientes[0].importe + this.datos_guardados[i].plazos_pendientes[0].gastos);
                        } else {
                            total = total + parseFloat(this.datos_guardados[i].plazos_pendientes[0].importe);
                        }                        
                    }
                    total += parseFloat(this.teatro.coste_envio_whatsapp);
                }

                if(this.lista_abonados.permitir_envio_a_domicilio && this.envio_domicilio) {
                    total += this.lista_abonados.precio_envio_a_domicilio;
                }
                
                if (this.datos_parcelas_compra && this.datos_parcelas_compra.length > 0) {
                    total += this.datos_parcelas_compra.reduce((sum, parcela) => {
                        const precio = parcela.precioSeleccionado.price_management_interno ?
                            parcela.precioSeleccionado.precio :
                            (parcela.precioSeleccionado.precio + parcela.precioSeleccionado.price_management);
                        return sum + parseFloat(precio || 0);
                    }, 0);
                }

                return total;
            },
            total_plazos_sin_gd() {
                var total = 0;
                for(var i in this.datos_guardados) {
                    if (this.datos_guardados[i].plazos_pendientes) {
                        total = total + parseFloat(this.datos_guardados[i].plazos_pendientes[0].importe);
                    }

                    if (this.datos_guardados[i].descuento.price_management_interno || (this.datos_parcelas_compra?.length > 0 && this.datos_parcelas_compra[0].precioSeleccionado.price_management_interno)) {
                        total += parseFloat(this.teatro.coste_envio_whatsapp);
                    }
                }

                if(this.lista_abonados.permitir_envio_a_domicilio && this.envio_domicilio) {
                    total += this.lista_abonados.precio_envio_a_domicilio;
                }
                
                if (this.datos_parcelas_compra && this.datos_parcelas_compra.length > 0) {
                    total += this.datos_parcelas_compra.reduce((sum, parcela) => {
                        return sum + parseFloat(parcela.precioSeleccionado.precio || 0); 
                    }, 0);
                }

                return total;
            },
            total() {
                var total = 0;
                for(var i in this.datos_guardados) {
                    if(this.datos_guardados[i].voucher) {
                        if(parseFloat(this.datos_guardados[i].voucher.discount_percent) > 0) {
                            total = total + (this.datos_guardados[i].descuento.precio_total - (parseFloat(this.datos_guardados[i].descuento.precio) * (parseFloat(this.datos_guardados[i].voucher.discount_percent) / 100)));
                        } else {
                            total = total + (parseFloat(this.datos_guardados[i].descuento.precio_total) - parseFloat(this.datos_guardados[i].voucher.discount_fixed))
                        }
                    } else {
                        total = total + parseFloat(this.datos_guardados[i].descuento.precio_total);
                    }
                    
                    if (this.datos_guardados) {
                        if(this.datos_guardados[i].descuento_monedero) {
                            total = total - this.datos_guardados[i].descuento_monedero;
                        }
    
                        total += parseFloat(this.teatro.coste_envio_whatsapp);
                    }
                }

                if(this.lista_abonados.permitir_envio_a_domicilio && this.envio_domicilio) {
                    total += this.lista_abonados.precio_envio_a_domicilio;
                }

                return total;
            },
            total_sin_gd() {
                var total = 0;
                for(var i in this.datos_guardados) {
                    if(this.datos_guardados[i].voucher) {
                        if(parseFloat(this.datos_guardados[i].voucher.discount_percent) > 0) {
                            total = total + (this.datos_guardados[i].descuento.precio - (parseFloat(this.datos_guardados[i].descuento.precio) * (parseFloat(this.datos_guardados[i].voucher.discount_percent) / 100)));
                        } else {
                            total = total + (parseFloat(this.datos_guardados[i].descuento.precio) - parseFloat(this.datos_guardados[i].voucher.discount_fixed))
                        }
                    } else {
                        total = total + parseFloat(this.datos_guardados[i].descuento.precio);
                    }

                    if(this.datos_guardados[i].descuento_monedero) {
                        total = total - this.datos_guardados[i].descuento_monedero;
                    }

                    if (this.datos_guardados[i].descuento.price_management_interno ||  (this.datos_parcelas_compra?.length > 0 && this.datos_parcelas_compra[0].precioSeleccionado.price_management_interno)) {
                        total += parseFloat(this.teatro.coste_envio_whatsapp);
                    }
                }

                if(this.lista_abonados.permitir_envio_a_domicilio && this.envio_domicilio) {
                    total += this.lista_abonados.precio_envio_a_domicilio;
                }

                return total;
            },
            total_gd() {
                var total = 0;

                for(var i in this.datos_guardados) {
                    if (!this.datos_guardados[i].descuento.price_management_interno) {
                        total = total + parseFloat(this.datos_guardados[i].descuento.price_management);
                    }
                }

                if (this.datos_parcelas_compra && this.datos_parcelas_compra.length > 0) {
                    total += this.datos_parcelas_compra.reduce((sum, parcela) => {
                        if (!parcela.precioSeleccionado.price_management_interno) {
                            return sum + parseFloat(parcela.precioSeleccionado.price_management || 0);
                        }
                        return sum;
                    }, 0);
                }

                return total;
            },
            envio_whatsapp() {
                const quierenEnvio = this.datos_guardados.some(dato_guardado => {
                    return dato_guardado.telefono;
                });

                return quierenEnvio && this.teatro.url_whatsapp_abonos ? true : false;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            footer() {
                return this.$store.getters.getFooter
            },
            total_sin_gd_con_parcelas() {
                let totalAbonos = this.total_sin_gd; 
                let totalParcelas = 0;

                if (this.datos_parcelas_compra && this.datos_parcelas_compra.length > 0) {
                    totalParcelas = this.datos_parcelas_compra.reduce((sum, parcela) => {
                        return sum + parseFloat(parcela.precioSeleccionado.precio || 0); 
                    }, 0);
                }
                
                return totalAbonos + totalParcelas;
            },
            total_con_parcelas() {
                let totalAbonos = this.total;
                let totalParcelas = 0;

                if (this.datos_parcelas_compra && this.datos_parcelas_compra.length > 0) {
                    totalParcelas = this.datos_parcelas_compra.reduce((sum, parcela) => {
                        const precio = parcela.precioSeleccionado.price_management_interno ?
                            parcela.precioSeleccionado.precio :
                            (parcela.precioSeleccionado.precio + parcela.precioSeleccionado.price_management);
                        return sum + parseFloat(precio || 0);
                    }, 0);
                }

                return totalAbonos + totalParcelas;
            },
        },
        methods: {
            terminar() {
                if (this.terminos) {
                    this.guardarTerminosCondiciones();
                    
                    if (this.formulario) {

                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 1000);
                    } else {

                        this.$emit('compraConfirmada');
                    }
                } else {
                    this.error = true;
                }
            },
            guardarTerminosCondiciones(){
                const data = {
                    filters: {
                        session_id: this.session_id,
                        privacidad: this.privacidad,
                        condiciones: this.condiciones,
                        comunicaciones: this.comunicaciones,
                        condiciones_plazos: this.condiciones_plazos
                    },
                    session_id: this.session_id,
                    privacidad: this.privacidad,
                    condiciones: this.condiciones,
                    comunicaciones: this.comunicaciones,
                    condiciones_plazos: this.condiciones_plazos
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.compra.terminos-y-condiciones'), data).then(res => { });
            },
            solicitarPlazos(data) {
                const params = {
                    filters: {
                        sesion_id: this.session_id,
                        tid: this.configuracion.hash_teatro
                    },
                    sesion_id: this.session_id,
                    frecuencias: data.frecuenciaSelect,
                    n_plazos: data.plazoSelect
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.compra.calcular.plazos'), params).then(res => {
                    if(! res.data.error) {
                        this.error_plazos = false;
                        this.quiere_plazos = true;
                        this.$emit('solicitarPlazos', res.data.datos_compradores);
                    } else {
                        this.error_plazos = true;
                        this.resetPlazos();
                    }
                    
                });
            },
            resetPlazos() {
                this.quiere_plazos = false;
                this.$emit('resetPlazos');
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones, condiciones_plazos) {
                if (continuar == true) {
                    this.terminos = true;
                    
                    this.privacidad = privacidad;
                    this.condiciones = condiciones;
                    this.comunicaciones = comunicaciones;
                    this.condiciones_plazos = condiciones_plazos;
                } else {
                    this.terminos = false;
                }
            },
            aplicarDescuento(descuento) {
                this.$emit('aplicarDescuento', descuento);
            },
            cancelarDescuento() {
                this.$emit('cancelarDescuento');
            },
            setConfigPlazos() {
                let max_plazos = 1000;
                let min_plazos = 0;
                let frecuencias = null;
                let activar_plazos = true;

                if (this.datos_guardados) {
                    this.datos_guardados.forEach(abono => {
                        if(abono.tipo_abono.activar_pago_plazos) {
                            if(abono.tipo_abono.min_cantidad_plazos > min_plazos) {
                                min_plazos = abono.tipo_abono.min_cantidad_plazos;
                            }
    
                            if(abono.tipo_abono.max_cantidad_plazos < max_plazos) {
                                max_plazos = abono.tipo_abono.max_cantidad_plazos;
                            }
    
                            if(frecuencias === null) {
                                frecuencias = abono.tipo_abono.frecuencias;
                            } else {
                                let items = [];
    
                                frecuencias.forEach((frecuencia, index) => {
                                    if(! abono.tipo_abono.frecuencias.find(({ id }) => id === frecuencia.id)) {
                                        items.push(index);
                                    }
                                })
    
                                items.forEach(item => {
                                    frecuencias.splice(item, 1);
                                })
                            }
                        } else {
                            activar_plazos = false;
                        }
                    });
                }

                this.max_plazos = max_plazos;
                this.min_plazos = min_plazos;
                if(activar_plazos) {
                    this.frecuencias = frecuencias;
                }            
            },
            volver(){
                this.$emit('volver')
            },
            calcularDescuento(entrada, plazos = false, aplicarVoucher = true, aplicarMonedero = true) {
                if (plazos && entrada.plazos_pendientes?.length) {
                    const plazo = entrada.plazos_pendientes[0];
                    return !plazo.gastos_internos ? (plazo.importe + plazo.gastos): plazo.importe;
                }

                let base = parseFloat(entrada.descuento.precio);

                if (aplicarVoucher && entrada.voucher) {
                    if (entrada.voucher.discount_percent > 0) {
                        base -= base * (entrada.voucher.discount_percent / 100);
                    } else if (entrada.voucher.discount_fixed > 0) {
                        base -= entrada.voucher.discount_fixed;
                    }
                }

                if (aplicarMonedero && entrada.descuento_monedero) {
                    base -= parseFloat(entrada.descuento_monedero);
                }

                return base > 0 ? (!entrada.descuento.price_management_interno ? base + entrada.descuento.price_management : base) : 0;
            },
            getGastosInternos() {
                if (this.datos_parcelas_compra && this.datos_parcelas_compra.length > 0) {
                    if (!this.datos_parcelas_compra[0].precioSeleccionado?.price_management_interno) {
                        return 0;
                    }
                }

                if (!this.datos_guardados[0].descuento.price_management_interno) {
                    return 0;
                }

                return 1;
            }
        },
        created() {
            if (this.teatro.permitir_plazos_abonados) {
                this.setConfigPlazos();
            }
        },
        components: { FormTerminos , ResumenPrecioComponent, BuscarReferidosComponent, SaldoMonederoComponent, AddPlazosComponent }
    }
</script>